
import {defineComponent} from "vue";
import CpsDetailWysiwyg from "@/components/layouts/content-pages/detail/CpsDetailWysiwyg.vue";

export default defineComponent({
  name: "ContentPagesDetailWysiwyg",
  components: {CpsDetailWysiwyg},
  props: ['mode', 'backRoute'],
  data() {
    return {
      id: this.$route.params.id as string,
    };
  },
});
